var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestPolicyDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M23.01 16.29a7.66 7.66 0 0 0-7.65 7.652 7.515 7.515 0 0 0 1.532 4.567 7.593 7.593 0 0 0 5.46 3.045h.659c.282-.001.563-.018.844-.049a7.641 7.641 0 0 0-.844-15.243v.029zm4.685 10.949a5.702 5.702 0 0 1-4.054 2.395c-.37.04-.744.04-1.115 0a5.702 5.702 0 0 1-4.102-2.289 5.585 5.585 0 0 1-1.154-3.423 5.74 5.74 0 1 1 10.425 3.297v.02zm-3.734-4.257v-2.735a.97.97 0 0 0-1.94 0v2.735h-2.705a.97.97 0 0 0 0 1.94h2.735v2.714a.97.97 0 0 0 1.94 0v-2.744h2.676a.97.97 0 1 0 0-1.94l-2.706.03zM15.69 30.06H6.43a1.193 1.193 0 0 1-1.232-1.135V8.902h4.984a1.852 1.852 0 0 0 1.94-1.814V2.91h13.313a1.193 1.193 0 0 1 1.232 1.106V15.99a.97.97 0 1 0 1.94 0V4.015A3.093 3.093 0 0 0 25.434.97H11.074a.834.834 0 0 0-.223 0 .368.368 0 0 0-.097 0 .747.747 0 0 0-.262.165L3.588 7.64a.97.97 0 0 0-.3.698v20.616A3.093 3.093 0 0 0 6.428 32h9.26a.97.97 0 0 0 0-1.94zM10.182 6.99H7.127l3.055-2.86v2.86z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPolicyDocument);
export default __webpack_public_path__ + "static/media/request-policy-document.05edfb5a26af4483d5748e5618b8e6a5.svg";
export { ForwardRef as ReactComponent };